import script from "./traffic-record-components.vue?vue&type=script&setup=true&lang=js"
export * from "./traffic-record-components.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__